// == Import npm
import React from "react";
import { Button, Modal } from "antd";
import { useDispatch } from "react-redux";

import { cancelVisit } from "services/features/VisitsSlice";
import { updateVisitsFromUser } from "services/features/VisitsSlice";

// == Import SCSS
import "./modalDelete.less";

// == Import icons
import { ReactComponent as Confirm } from "assets/illustrations/confirm.svg";

// == Import components

import { useTranslation } from "react-i18next";

const ModalDelete = ({ isVisible, setVisible, visit, currentVisitor }) => {
  const [t] = useTranslation();

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const dispatch = useDispatch();

  const handleDelete = async () => {
    await dispatch(cancelVisit(visit.id));
    if (currentVisitor) await dispatch(updateVisitsFromUser(currentVisitor));
    setVisible(false);
  };

  return (
    <div>
      <Modal
        className="modalDelete"
        width="700px"
        open={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={
          <>
            <Button
              type="primary"
              style={{ width: "150px" }}
              size="large"
              className="modalDelete__modal__yes"
              onClick={handleDelete}
            >
              {t("Yes")}
            </Button>
            <Button
              style={{ width: "150px" }}
              type="default"
              size="large"
              className="modalDelete__modal__no"
              onClick={handleOk}
            >
              {t("No")}
            </Button>
          </>
        }
      >
        <p className="modalDelete__modal__text">
          {t("DeleteConfirm")} <br /> {t("DeleteConfirm2")} ?
        </p>
        <Confirm />
      </Modal>
    </div>
  );
};

export default ModalDelete;
